import { z } from 'zod';
import i18n from '@/i18n';

export const signInEmailSchema = z.object({
    email: z
        .string()
        .trim()
        // @ts-ignore
        .min(1, i18n.t('email_required'))
        // @ts-ignore
        .max(100, i18n.t('email_too_long'))
        // @ts-ignore
        .regex(
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            i18n.t('auth.email_not_correct')
        )
        .refine((val) => val.trim().length > 0, {
            // @ts-ignore
            message: i18n.t('email_can_not_consist_only_of_spaces'),
        })
});

export type SignInEmailType = z.infer<typeof signInEmailSchema>;
